import { useState } from "react";
import { useAuth } from "../context/authContext";
import Layout from "../layout/layout";

const Referral = () => {
    const {
        prefix,
        userId
    } = useAuth();

    const referralCode = `${window.location.origin}/signup/${prefix}${userId}`;

    const [message, setMessage] = useState("");
    const [message1, setMessage1] = useState("");

    const handleCopy = async (text, isCopyCode) => {
        try {
            await navigator.clipboard.writeText(text);
            if (isCopyCode) {
                setMessage("Copied");
                setTimeout(() => {
                    setMessage("");
                }, 3000);
            } else {
                setMessage1("Copied");
                setTimeout(() => {
                    setMessage1("");
                }, 3000);
            }
        } catch (e) {

        }
    }

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth p-4">
                    <div className="desktop-card card">
                        <div className="card-header">
                            <h5> Invite via Referral Code Referral Link </h5>
                        </div>
                        <div className="card-body  bg-dark pt-4">
                            <div className="row">
                                <div className="col-md-6">
                                    <p className="" style={{ color: "rgb(255 174 176)" }}>Referral Code:</p>
                                    <div className="referral-code-value" onClick={() => handleCopy(prefix + userId, true)}>
                                        <span>{prefix + userId}</span>
                                        <i className="fa fa-copy"></i>
                                    </div>
                                    <div className="text-right text-success">
                                        {message && <span>{message}</span>}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <p className="" style={{ color: "rgb(255 174 176)" }}>Referral Link:</p>
                                    <div className="referral-code-value" onClick={() => handleCopy(referralCode)}>
                                        <span className="txt-ellipsis-1">{referralCode}</span>
                                        <i className="fa fa-copy"></i>
                                    </div>
                                    <div className="text-right text-success">
                                        {message1 && <span>{message1}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default Referral;